// Generate a random password
export const generatePassword = (): string => {
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const special = '!@#$&';

  // Ensure at least one of each required type
  let password = '';
  password += upper.charAt(Math.floor(Math.random() * upper.length));
  password += lower.charAt(Math.floor(Math.random() * lower.length));
  password += digits.charAt(Math.floor(Math.random() * digits.length));
  password += special.charAt(Math.floor(Math.random() * special.length));

  // Fill remaining 8 characters with letters, digits, and special chars
  const all = upper + lower + digits + special;
  for (let i = 0; i < 8; i++) {
    password += all.charAt(Math.floor(Math.random() * all.length));
  }

  // Shuffle to randomize positions
  return password
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');
};

// Table pagination options
export const paginationOptions = {
  showSizeChanger: true,
  pageSizeOptions: ['10', '15', '50', '100'],
  defaultPageSize: 15,
  showTotal: (total: number, range: [number, number]) =>
    `Showing ${range[0]}-${range[1]} of ${total} employees`,
};
